import React, { Component } from 'react'
import { connect } from 'react-redux'
import { signIn } from '../../store/actions/authActions'
import { Redirect } from 'react-router-dom'

class SignIn extends Component {
  state = {
    email: '',
    password: ''
  }
  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value
    })
  }
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.signIn(this.state)
  }
  render() {
    const { authError, auth } = this.props
    if (auth.uid) return <Redirect to='/' /> 
    return (
      <div className="container row">
        <div className="col m8">
          <form className="white card" onSubmit={this.handleSubmit} >
            <span className="card-title grey-text text-darken-3">Sign In</span>
            <div className="input-field">
              <input type="email" id="email" onChange={this.handleChange}/>
              <label htmlFor="email">Email</label>
            </div>
            <div className="input-field">
              <input type="password" id="password" onChange={this.handleChange}/>
              <label htmlFor="password">Password</label>
            </div>
            <div className="input-field">
              <button className="btn blue lighten-1 ">
                Login
              </button>
              <div className="red-text center">
                { authError ? <p>{authError}</p> : null }
              </div>
            </div>
          </form>

        </div>
        <div className="col m4">
          <div className="card">
            <div className="card-content">
              <span className="card-title">Test user</span>
              <p>login: test@test.tt</p>
              <p>passwd: testtest</p>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    authError: state.auth.authError,
    auth: state.firebase.auth
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    signIn: (creds) => dispatch(signIn(creds))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SignIn)



// WEBPACK FOOTER //
// ./src/components/auth/SignIn.js